const { debounce } = window.BAO.Utils

class LocalizationFormControllerHeader extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    this.countryListArray = []
    this.logKeyPress = []

    this.externalEls?.['countries-list']?.element
      .querySelectorAll('button')
      .forEach(btn => {
        const isoCode = btn.dataset.value
        const countryLabel = btn.dataset.label

        this.countryListArray.push({
          isoCode,
          countryLabel: countryLabel.toLowerCase(),
        })
      })
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.onTriggerClick.bind(this),
    )

    if (this.externalEls?.currency?.exists) {
      this.externalEls.currency.elements.forEach(currencyEl => {
        this.listeners.add(currencyEl, `click`, this.onTriggerClick.bind(this))
      })
    }

    this.externalEls?.country?.elements?.forEach(countryEl => {
      this.listeners.add(
        countryEl,
        'click',
        this.handleShippingSelectChange.bind(this),
      )
    })

    if (this.countryListEl) {
      this.countryListEl.addEventListener('scroll', this.onScroll.bind(this), {
        passive: true,
      })

      this.externalEls?.country?.elements?.forEach(countryEl => {
        this.listeners.add(
          countryEl,
          'mouseover',
          this.handleCountryHover.bind(this),
        )
      })

      this.findCountry = this.findCountry.bind(this)
      this.debouncedFindCountry = debounce(event => {
        this.findCountry(event)
      }, 500)
      this.listeners.add(window, 'keydown', event => {
        this.externalEls?.country?.elements?.forEach(countryEl => {
          countryEl.parentElement.classList.remove(
            'hd-Banner_ShippingCountry-focused',
          )
        })

        this.logKeyPress.push(event.key)

        this.debouncedFindCountry(event)
      })
    }

    this.listeners.add(this.externalEls.close.element, 'click', () =>
      this.closeShippingSelect(),
    )
  }

  findCountry (event) {
    const filteredOptions = this.countryListArray.filter(country =>
      country.countryLabel.startsWith(this.logKeyPress.join('')),
    )

    if (filteredOptions.length > 0) {
      const selectedOption = filteredOptions[0]

      const selectedButton = this.externalEls['countries-list'].element.querySelector(
        `${this.externalEls.country.selector}[data-label="${selectedOption.countryLabel}"]`,
      )

      selectedButton.parentElement.classList.add(
        'hd-Banner_ShippingCountry-focused',
      )

      selectedButton.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })
    }

    this.logKeyPress = []
  }

  handleCountryHover (event) {
    this.externalEls.country?.elements?.forEach(countryEl => {
      countryEl.parentElement.classList.remove(
        'hd-Banner_ShippingCountry-focused',
      )
    })
  }

  appendParamsToReturnUrl () {
    if (!this.returnUrlInput) {
      return
    }
    this.returnUrlInput.value = `${this.returnUrlInput.value}`
  }

  handleShippingSelectChange (event) {
    const shippingSelectEl = document.querySelector('.hd-Banner_ShippingSelect')

    document.dispatchEvent(
      new CustomEvent('AFTER_SHIPPING_SELECT_CHANGE', {
        detail: {
          countryCode: event.target.getAttribute('data-value'),
        },
      }),
    )

    shippingSelectEl.value = event.target.getAttribute('data-value')

    this.externalEls?.modal?.element?.setAttribute('aria-hidden', 'true')

    document.body.style.removeProperty('overflow')

    shippingSelectEl.dispatchEvent(new Event('change'))
  }

  onScroll (event) {
    const countryListEl = event.target

    const scrollTop = countryListEl.scrollTop
    const scrollHeight = countryListEl.scrollHeight
    const offsetHeight = countryListEl.offsetHeight
    const amountScrolled = scrollHeight - offsetHeight
    countryListEl.toggleAttribute('scrollstart', scrollTop <= 40)
    countryListEl.toggleAttribute('scrollend', scrollTop >= amountScrolled - 40)
  }

  onTriggerClick () {
    this.externalEls?.modal?.element?.setAttribute('aria-hidden', 'false')
    this.externalEls?.close?.element.setAttribute('aria-hidden', 'false')

    document.body.style.setProperty('overflow', 'hidden')

    if (this.countryListEl) {
      this.countryListEl.scrollTop =
        this.externalEls?.['current-country']?.element?.offsetTop - 25
    }
  }

  closeShippingSelect () {
    this.externalEls?.modal?.element?.setAttribute('aria-hidden', 'true')
    this.externalEls?.close?.element.setAttribute('aria-hidden', 'true')

    document.body.style.removeProperty('overflow')
  }

  get countryListEl () {
    return this.externalEls?.['countries-list']?.element
  }

  /** @type {HTMLFormElement} */
  get form () {
    return this.closest('form')
  }

  /** @type {HTMLInputElement} */
  get returnUrlInput () {
    return this.form.querySelector('input[name="return_to"]')
  }
}

if (!window.customElements.get('localization-form-controller-header')) {
  window.customElements.define(
    'localization-form-controller-header',
    LocalizationFormControllerHeader,
  )
}
